import {models} from 'jkurwa';
import {Buffer} from 'buffer';
import {certIds} from '../kep/box.js';
// Рядок касира з відкритого сертифіката підпису. Ідентифікатор — SKI (розширення Subject Key Identifier), не хеш DER.
export function cashierFromCert(c){
 if(!c.canUseFor('sign'))throw Error('Потрібен сертифікат цифрового підпису, а не шифрування');
 const ski=c.extension?.subjectKeyIdentifier;if(!ski)throw Error('У сертифікаті немає ідентифікатора ключа суб’єкта');
 const tin=String(certIds(c).drfo||'');
 if(!/^\d{10}$/.test(tin))throw Error('У сертифікаті немає РНОКПП касира; перевірте реквізити вручну');
 return {T1RXXXXG1S:c.subject.commonName||'',T1RXXXXG2S:tin,T1RXXXXG3S:Buffer.from(ski).toString('hex'),T1RXXXXG4S:'Касир'};
}
// Файл .cer читаємо лише локально
export function cashierFromCertificate(bytes){
 let c;try{c=models.Certificate.from_pem(Buffer.from(bytes));}catch{throw Error('Не вдалося прочитати сертифікат .cer');}
 return cashierFromCert(c);
}
// Відкритий у браузері ключ касира: беремо сертифікат підпису (його знаходить loadKey у центрі, що видав ключ)
export function cashierFromBox(box){
 const k=box.keys.find(k=>k.priv&&k.cert&&k.cert.canUseFor('sign'));
 if(!k)throw Error('До ключа не знайдено сертифіката підпису — виберіть файл .cer касира');
 return cashierFromCert(k.cert);
}
